const id_master_storage = {
    '': "ruang penyimpanan",
    name: "nama ruang penyimpanan",
    add: "tambah ruang penyimpanan",
    edit: "ubah ruang penyimpanan",

    error: {
        name: "Nama penyimpanan tidak boleh kosong",
        create: "Gagal membuat ruang penyimpanan",
        delete: "Gagal menghapus ruang penyimpanan",
        edit: "Gagal mengubah ruang penyimpanan",
    },

    success: {
        name: "Nama penyimpanan tidak boleh kosong",
        create: "Berhasil membuat ruang penyimpanan",
        delete: "Berhasil menghapus ruang penyimpanan",
        edit: "Berhasil mengubah ruang penyimpanan",
    }
}

export default id_master_storage;